// Delegated so `#chat` links work wherever the merchant adds them — rich text
// (which strips onclick on save), link pickers, menus — and in markup rendered
// after load. `$=` also catches link pickers that store `/#chat` or a full URL.
document.addEventListener("click", (event) => {
  const link = event.target.closest('a[href$="#chat"]');
  if (!link || !window.GorgiasChat) return;

  event.preventDefault();
  // The global exists before the widget is ready, and calling the API early
  // throws; `init()` resolves once it's ready (immediately if it already is).
  window.GorgiasChat.init().then(() => window.GorgiasChat.open());
});
